import { ArenaTournament } from 'modules/arena/tournaments/types';
import { TOURNAMENT_STATUS_LABELS } from 'modules/arena/tournaments/content';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { Button } from 'shared/components/ui/Button';
import { CategoryAdminCard } from 'modules/arena/tournaments/components/CategoryAdminCard';

interface TournamentDetailPanelProps {
  tournament: ArenaTournament;
  onConfirmRegistration: (categoryId: string, registrationId: string) => void;
  onCancelRegistration: (categoryId: string, registrationId: string) => void;
  onPromoteFromWaitlist: (categoryId: string, waitlistId: string) => void;
  onPublish: (id: string) => void;
  onClose: (id: string) => void;
}

const STATUS_TONE = {
  rascunho: 'neutral',
  publicado: 'success',
  encerrado: 'accent',
} as const;

export function TournamentDetailPanel({
  tournament,
  onConfirmRegistration,
  onCancelRegistration,
  onPromoteFromWaitlist,
  onPublish,
  onClose,
}: TournamentDetailPanelProps) {
  return (
    <Card>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">Torneio</p>
          <h3 className="mt-1 font-heading text-lg font-semibold text-ink">{tournament.name}</h3>
          <p className="text-sm text-ink-secondary">
            {tournament.sport} · {tournament.court} · {tournament.dateLabel}
          </p>
        </div>
        <Badge tone={STATUS_TONE[tournament.status]}>{TOURNAMENT_STATUS_LABELS[tournament.status]}</Badge>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
        <div>
          <p className="text-xs text-ink-secondary">Prazo de inscrição</p>
          <p className="font-medium text-ink">{tournament.registrationDeadlineLabel}</p>
        </div>
        <div>
          <p className="text-xs text-ink-secondary">Prazo de cancelamento</p>
          <p className="font-medium text-ink">{tournament.cancellationDeadlineLabel}</p>
        </div>
        <div>
          <p className="text-xs text-ink-secondary">Valor de inscrição</p>
          <p className="font-medium text-ink">{tournament.entryFeeLabel}</p>
        </div>
        <div>
          <p className="text-xs text-ink-secondary">Premiação</p>
          <p className="font-medium text-ink">{tournament.prizeLabel}</p>
        </div>
      </div>

      <div className="mt-4">
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">Categorias</p>
        <div className="mt-2 flex flex-col gap-3">
          {tournament.categories.map((category) => (
            <CategoryAdminCard
              key={category.id}
              category={category}
              onConfirmRegistration={onConfirmRegistration}
              onCancelRegistration={onCancelRegistration}
              onPromoteFromWaitlist={onPromoteFromWaitlist}
            />
          ))}
        </div>
      </div>

      {tournament.status === 'rascunho' && (
        <Button className="mt-5 w-full" onClick={() => onPublish(tournament.id)}>
          Publicar torneio
        </Button>
      )}
      {tournament.status === 'publicado' && (
        <Button variant="ghost" className="mt-5 w-full" onClick={() => onClose(tournament.id)}>
          Encerrar torneio
        </Button>
      )}
    </Card>
  );
}
